import React from "react";
import { NotFoundPage } from "../../../components/common";

interface NoAdminFoundProps {
  handleClick?: () => void;
}

const NoAdminFound = (props: NoAdminFoundProps) => {
  return (
    <div className="no-jobs-found-wrapper no-admin-found-wrapper">
      <NotFoundPage
        variant="admin"
        title="No Admins Found"
        description="Add admins to level up your employHER network"
        monitorText="No Admin"
        displayAddNewButton={true}
        buttonText="Add New Admin"
        handleClick={props.handleClick}
      />
    </div>
  );
};

export default NoAdminFound;
